import React, { useEffect, useReducer } from "react";

import { getCurrentPrepaidBalance } from "./helpers";
import { reducer, initialState } from "./reducers";
import { setCurrentPrepaidBalance } from "./actionCreators";
import { ParagraphStyled } from "./styles";

const PrepaidBalancePage = () => {
    const [state, dispatch] = useReducer(reducer, initialState);

    // retrieves user's current prepaid balance and sets in state
    useEffect(() => {
        getCurrentPrepaidBalance().then(balanceInDollars => {
            dispatch(
                setCurrentPrepaidBalance({
                    currentPrepaidBalance: balanceInDollars
                })
            );
        });
    }, []);

    return (
        <div className="settings-prepaid account-fields">
            <section className="balance">
                <header>
                    <h3>My Prepaid Icon Balance</h3>
                </header>
                <div className="message-to-user">
                    <i className="ui_wallet" />A prepaid icon balance never
                    expires. Use any time for any icon purchase. Currently
                    balances may be used for icon purchases only, photos may be
                    purchased separately.
                </div>
                <div className="current-balance">
                    Current Balance: ${state.currentPrepaidBalance.toFixed(2)}
                </div>
            </section>

            <ParagraphStyled type="p" size="md">
                Adding prepaid credit to your balance is no longer available.
                However, you may continue to purchase icons with any existing
                prepaid balance.
            </ParagraphStyled>
        </div>
    );
};

export default PrepaidBalancePage;
